import { Box, Typography } from "@material-ui/core";
import * as React from "react";

import { CustomButton } from "@/components/Button";
import { getAppVersionTag, initializeAppInfo } from "@/utilities/appInfo";
import { sendEventToAppMeasurementTool, isFirstAccess, AppEventTokenEnum } from "@/utilities/capacitorLogic";

import { SettingItemsProps } from "../../SettingsPage";
import { SettingsHelper, useSettingsContentStyles } from "../SettingsContent";

export const getDeviceDescription = () => {
  const userAgent = navigator.userAgent;
  const ios = userAgent.match(/(?:iPhone|iPad).*OS ([\d_]+)/);
  if (ios) return `${/iPad/.test(userAgent) ? "iPad" : "iPhone"} / iOS ${ios[1].replace(/_/g, ".")}`;
  const android = userAgent.match(/Android ([\d.]+)/);
  if (android) return `Android ${android[1]}`;
  return navigator.platform || "取得できません";
};
export const ReportTab: React.FC<SettingItemsProps> = ({ user }) => {
  const classes = useSettingsContentStyles();
  const [version, setVersion] = React.useState(getAppVersionTag());
  React.useEffect(() => {
    let mounted = true;
    Promise.resolve(initializeAppInfo()).then(() => {
      if (mounted) setVersion(getAppVersionTag());
    });
    return () => {
      mounted = false;
    };
  }, []);
  const onClickReport = () => {
    sendEventToAppMeasurementTool(
      isFirstAccess(user?.created_at)
        ? AppEventTokenEnum.ReportFirstAccess
        : AppEventTokenEnum.ReportSecondOnwardsAccess
    );
    window.open("https://form.run/@propally-1619963249", "_blank");
  };
  return (
    <>
      <Box className={classes.stack}>
        <Box>
          <Typography component="h2" className={classes.heading}>
            不具合・ご要望
          </Typography>
          <Box mt={1}>
            <Typography className={classes.description}>
              うまく動かないところも、こうしてほしいという要望も、同じフォームから送れます。
            </Typography>
          </Box>
        </Box>
        <Box className={classes.note} style={{ gap: 12 }}>
          {[
            { label: "バージョン", value: version || "取得できません" },
            { label: "端末", value: getDeviceDescription() },
            { label: "ID", value: user.identifier },
          ].map((item) => (
            <Box key={item.label} display="flex" justifyContent="space-between" style={{ gap: 16 }}>
              <Typography className={classes.caption}>{item.label}</Typography>
              <Typography className={classes.address}>{item.value}</Typography>
            </Box>
          ))}
          <Typography className={classes.caption}>お問い合わせの際にこちらの情報をお知らせください。</Typography>
        </Box>
      </Box>
      <Box className={classes.actions}>
        <SettingsHelper>ブラウザが開きます。</SettingsHelper>
        <CustomButton buttonSize="L" onClick={onClickReport}>
          お問い合わせフォームを開く
        </CustomButton>
      </Box>
    </>
  );
};
